import React from 'react';
import Tooltip from '@homeaway/react-tooltip';
import {IS_BROWSER} from '../../../utils/dynamic-rendering';

function ListingBadges({isDesktop, items = []}) {
    const props = {
        tooltipType: 'popover',
        placement: 'top',
        centered: true,
        ...(IS_BROWSER && {
            parentNode: window.document.body,
        }),
    };

    return (
        items.length > 0 && (
            <div className="ListingBadges__container">
                {items.map((item) =>
                    isDesktop && item.helpText ? (
                        <Tooltip
                            {...props}
                            content={item.helpText}
                            key={item.name}
                        >
                            <span className="label label-default">
                                {item.name}
                            </span>
                        </Tooltip>
                    ) : (
                        <span className="label label-default" key={item.name}>
                            {item.name}
                        </span>
                    )
                )}
            </div>
        )
    );
}

export default React.memo(ListingBadges);
